import { type MapColorTheme, type ResolvedMapColorTheme } from './map-theme';

/** Resolve light/dark variants for each map color token. */
export function resolveMapColorTheme(
  theme: MapColorTheme,
  baseTheme: 'light' | 'dark',
): ResolvedMapColorTheme {
  return Object.fromEntries(
    Object.entries(theme).map(([key, value]) => {
      if (typeof value === 'object') {
        return [key, value[baseTheme]];
      }
      return [key, value];
    }),
  ) as ResolvedMapColorTheme;
}
